import { z } from "zod"

export const organizationRolesEnum = z.enum(["admin", "customer_manager"])

export type OrganizationRoles = z.infer<typeof organizationRolesEnum>

export const ORGANIZATION_ROLE_TRANSLATIONS: Record<OrganizationRoles, string> =
  {
    admin: "Admin",
    customer_manager: "Contactpersoon",
  }

export const ORGANIZATION_ROLE_OPTIONS: {
  label: string
  value: OrganizationRoles
}[] = Object.entries(ORGANIZATION_ROLE_TRANSLATIONS).map(([value, label]) => ({
  label,
  value: value as OrganizationRoles,
}))

export type OrganizationUserRole = "admin" | "customer_manager"
